module.exports = {"coverAndPrinting.TocPage.characterPrefixDropDown.v1":"Chapter & Number","coverAndPrinting.TocPage.characterPrefixDropDown.v2":"Number Only","coverAndPrinting.TocPage.characterPrefixDropDown.v3":"None","courseInformation.school.select_no_school_error_CA":"No results for this postal code","courseInformation.school.select_no_school_error_US":"No results for this zip code","courseInformation.school.select_school_label":"Select Institution","courseInformation.school.name_of_institution":"Name of Institution"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en.json
// module id = 208
// module chunks = 0